<div [matTooltip]="text"
     class="truncated-text"
     matTooltipClass="tooltip-no-truncate">{{text}}
</div>
